"use client";

import { Briefcase, FileText, Film, Target } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  icon: Briefcase,
  title: "Project Management",
  description: "Hands-on project management tailored to your needs, removing daily operational stress so you can focus on execution and results.",
  link: "/ServicesPage"
}, {
  id: 2,
  icon: FileText,
  title: "Administrative Assistance",
  description: "Professional administrative support designed to help individuals and small businesses operate more efficiently and stay organized.",
  link: "/ServicesPage"
}, {
  id: 3,
  icon: Film,
  title: "Film Project Development & Packaging",
  description: "Specialized services structuring film projects to attract funding and connecting creators with essential relationships and infrastructure.",
  link: "/FilmDevelopmentPage"
}];
export default function CoreServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section className="py-16 px-6 md:px-8 lg:px-12 bg-background">
      <div className="max-w-7xl mx-auto" ref={ref}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
            Core Services
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Strategic support and professional services designed to accelerate
            your business and creative projects.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className={`group hover:shadow-medium transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] hover:-translate-y-1 ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : "animate-fade-in-up-delay-200" : "opacity-0"}`}>
                <CardHeader>
                  <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-md bg-primary/10 text-primary">
                    <Icon className="size-6" />
                  </div>
                  <CardTitle className="text-xl group-hover:underline transition-all duration-[80ms]">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {service.description}
                  </p>
                  <Link to={service.link}>
                    <Button variant="ghost" size="sm" className="group/btn transition-all duration-[80ms] hover:scale-[1.02]">
                      Learn More
                      <Target className="size-4 ml-1 group-hover/btn:translate-x-0.5 transition-transform" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}